import { createFileRoute } from "@tanstack/react-router";
import AdminDashboardPage from "@/app/admin/[id]/page";

export const Route = createFileRoute("/admin/$id/")({
  component: AdminDashboardPage,
});
